import React, { createContext, useContext, useState, useRef, Dispatch, SetStateAction } from 'react';

interface SettingsContextValue {
  useBrandGuidelines: boolean;
  setUseBrandGuidelines: (use: boolean) => void;
  excludedAssetIds: string[];
  setExcludedAssetIds: Dispatch<SetStateAction<string[]>>;
  isExpanded: boolean;
  setIsExpanded: Dispatch<SetStateAction<boolean>>;
  brandAssets: BrandAsset[];
  setBrandAssets: Dispatch<SetStateAction<BrandAsset[]>>;
  brandDefaultApplied: React.MutableRefObject<boolean>;
}

const SettingsContext = createContext<SettingsContextValue | null>(null);

export const useSettings = (): SettingsContextValue => {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error('useSettings must be used within a SettingsProvider');
  return ctx;
};

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [useBrandGuidelines, setUseBrandGuidelines] = useState(false);
  const [excludedAssetIds, setExcludedAssetIds] = useState<string[]>([]);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [brandAssets, setBrandAssets] = useState<BrandAsset[]>([]);
  const brandDefaultApplied = useRef(false);

  return (
    <SettingsContext.Provider value={{ useBrandGuidelines, setUseBrandGuidelines, excludedAssetIds, setExcludedAssetIds, isExpanded, setIsExpanded, brandAssets, setBrandAssets, brandDefaultApplied }}>
      {children}
    </SettingsContext.Provider>
  );
};
